<script lang="ts">
	import { useDrawer } from "@components/utils/useDrawer";
	import ClearIcon from "@svg/ClearIcon.svelte";
	import Home from "@svg/Home.svelte";
	import Person from "@svg/Person.svelte";
	import Movie from "@svg/Movie.svelte";
	import Policy from "@svg/Policy.svelte";
	import Terms from "@svg/Terms.svelte";
	import Contact from "@svg/Contact.svelte";
	import MenuItem from "./MenuItem.svelte";
	import FavoriteIcon from "@svg/FavoriteIcon.svelte";

	export let pathname: string | null = null;
	const { close } = useDrawer();

	interface MenuItemType {
		href: string;
		icon: any;
		label: string;
		cssClass?: string;
	}

	const menuItems: MenuItemType[] = [
		{ href: "/", icon: Home, label: "Home" },
		{ href: "/profile", icon: Person, label: "Profiel" },
		{ href: "/videos", icon: Movie, label: "Videos" },
		{ href: "/favourites", icon: FavoriteIcon, label: "Favorieten" },
		{
			href: "/contact",
			icon: Contact,
			label: "Contact",
			cssClass: "lg:mt-auto mt-4"
		},
		{ href: "/privacy-policy", icon: Policy, label: "Privacy policy" },
		{ href: "/terms-of-service", icon: Terms, label: "Terms of service" }
	];

	function isActive(path: string): boolean {
		if (path === "/" && pathname === "/") return true;
		if (path !== "/" && pathname?.includes(path)) return true;
		return false;
	}
</script>

<button class="p-2 lg:hidden" on:click={close}>
	<ClearIcon />
</button>

<div class="flex h-full flex-col pt-3">
	{#each menuItems as { href, icon, label, cssClass }}
		<MenuItem
			{href}
			{icon}
			{label}
			{cssClass}
			isActive={isActive(href)}
			onClick={close}
		/>
	{/each}
</div>
